import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class Spare extends React.Component {
    render() {
        const { t } = this.props;

        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center w-100">
                <div style={{ maxWidth: 720 }} className="w-100 px-3">
                    <h1 className="spare text-center" style={{ color: "#3366ff", margin: 0 }}>
                        {t("spareWelcome:title")}
                    </h1>

                    <h3 className="spare text-center" style={{ margin: "12px 0 20px" }}>
                        {t("spareWelcome:subtitle")}
                    </h3>

                    {/* List is left-aligned; block itself sits centered */}
                    <ol
                        className="text-start mx-auto"
                        style={{ listStylePosition: "inside", marginBottom: 20, maxWidth: 560 }}
                    >
                        <li style={{ marginBottom: 12 }}>{t("spareWelcome:steps.addCash")}</li>
                        <li style={{ marginBottom: 12 }}>{t("spareWelcome:steps.browse")}</li>
                        <li style={{ marginBottom: 12 }}>{t("spareWelcome:steps.showCode")}</li>
                    </ol>

                    <h4 className="spare text-center" style={{ marginBottom: 20 }}>
                        {t("spareWelcome:bookmark")}
                    </h4>

                    <div className="d-flex justify-content-center">
                        <Link to="/dashboard" className="action-button btn">
                            {t("spareWelcome:getStarted")}
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation(["spareWelcome"])(Spare);